'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _auth = require('./auth');

var _auth2 = _interopRequireDefault(_auth);

var _applicationForm = require('./applicationForm');

var _applicationForm2 = _interopRequireDefault(_applicationForm);

var _reduxForm = require('redux-form');

var _violetPaginator = require('violet-paginator');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routerReducer,
  reduxAsyncConnect: _reduxAsyncConnect.reducer,
  auth: _auth2.default,
  form: _reduxForm.reducer,
  applicationForm: _applicationForm2.default,
  pagination: _violetPaginator.pagination
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/reducer.js
// module id = 1124
// module chunks = 0